import dayjs from 'dayjs';

import { TSubscription } from '@mopla/data-models';

import { ICancellationDates } from '../types';

export const getCancellationDates = (
	subscription: TSubscription
): ICancellationDates => {
	const today = dayjs();

	// nextCancellationEffectiveDate shows the last valid day of the subscription if you cancel it now. This date is always present unless it's past the cancellation date (= subscription is already cancelled).
	// canceledAt is the first invalid day after the subcription is cancelled. Use canceledAt - 1 day to display the correct date when user wants to cancel the cancellation.
	const validUntilDayjs = subscription?.canceledAt
		? dayjs(subscription.canceledAt).subtract(1, 'day')
		: subscription?.nextCancellationEffectiveDate
		? dayjs(subscription.nextCancellationEffectiveDate)
		: today.endOf('month');

	const validUntilDate = validUntilDayjs.format('DD.MM.YYYY');
	const validUntilDateLong = validUntilDayjs.format('DD. MMMM YYYY');
	const invalidFromDate = validUntilDayjs.add(1, 'day').format('DD.MM.YYYY');
	const todayDate = today.format('DD.MM.YYYY');
	const pauseStartDate = subscription?.pauseStart
		? dayjs(subscription.pauseStart).format('DD.MM.YYYY')
		: '';
	const pauseEndDate = subscription?.pauseEnd
		? dayjs(subscription.pauseEnd).add(1, 'day').format('DD.MM.YYYY')
		: '';
	// cancellationNoticeDeadline points to the NEXT deadline (e.g. next month's 10th).
	// For the "out of time" warning, we show the deadline that already passed (current month's 10th).
	const cancellationNoticeDeadlineDayjs =
		subscription?.cancellationNoticeDeadline
			? dayjs(subscription.cancellationNoticeDeadline)
			: null;

	const cancellationNoticeDeadlineDate = cancellationNoticeDeadlineDayjs
		? cancellationNoticeDeadlineDayjs.subtract(1, 'month').format('DD.MM.')
		: '';

	// Long format of the deadline itself (e.g. "10. Juni") — used for the "in time" info message.
	const cancellationNoticeDeadlineDateLong = cancellationNoticeDeadlineDayjs
		? cancellationNoticeDeadlineDayjs.format('DD. MMMM')
		: '';

	// The end of the NEXT month after the deadline — the date the cancellation period extends to
	// if the user misses the deadline (e.g. deadline is 10. Juni → extends to 31.07.2026).
	const extendedCancellationDate = cancellationNoticeDeadlineDayjs
		? cancellationNoticeDeadlineDayjs
				.add(1, 'month')
				.endOf('month')
				.format('DD.MM.YYYY')
		: '';

	const subscriptionStartDateLong = subscription?.subscriptionStart
		? dayjs(subscription.subscriptionStart).format('DD. MMMM YYYY')
		: '';

	const dates = {
		validUntilDate,
		validUntilDateLong,
		invalidFromDate,
		todayDate,
		pauseStartDate,
		pauseEndDate,
		cancellationNoticeDeadlineDate,
		cancellationNoticeDeadlineDateLong,
		extendedCancellationDate,
		subscriptionStartDateLong,
	};

	return dates;
};
